import Lenis from "lenis";

let lenis = null;

export const initLenis = () => {
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  let id;
  const raf = (t) => {
    lenis?.raf(t);
    id = requestAnimationFrame(raf);
  };
  id = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(id);
    lenis?.destroy();
    lenis = null;
  };
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const lockScroll = (on) => {
  if (!lenis) return;
  if (on) lenis.stop();
  else lenis.start();
};
